import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const ResourcesIcon = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    {...props}>
    <Path
      fill="#8697AB"
      d="M15 10a1 1 0 0 0-1-1H6a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1ZM13.667 14a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2h6.667a1 1 0 0 0 1-1ZM14 17a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2h8Z"
    />
    <Path
      fill="#8697AB"
      fillRule="evenodd"
      d="M5 26h17.333A3.667 3.667 0 0 0 26 22.333V15a1 1 0 0 0-1-1h-4.333V3.59c0-1.897-2.146-3-3.69-1.898l-.233.167c-1.04.743-2.45.74-3.496-.006a5.026 5.026 0 0 0-5.83 0 3.013 3.013 0 0 1-3.495.006l-.233-.167C2.145.59 0 1.693 0 3.591V21a5 5 0 0 0 5 5ZM8.581 3.48a3.026 3.026 0 0 1 3.504 0 5.013 5.013 0 0 0 5.821.006l.234-.166c.22-.158.527 0 .527.271v18.742c0 .6.144 1.167.4 1.667H5a3 3 0 0 1-3-3V3.59c0-.27.306-.428.527-.27l.233.166a5.013 5.013 0 0 0 5.821-.006Zm12.086 18.853V16H24v6.333a1.667 1.667 0 0 1-3.333 0Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default ResourcesIcon;
